import { get } from './apiClient';

export function checkHealth() {
  return get('/health');
}